var kombi = {
  getOnlyDigits: function (text) {
    return text.replace(/\D/g, "");
  },

  getCheckoutCartId: function () {
    var byId = document.getElementById("cart_id");
    if (byId && byId.value) {
      return byId.value;
    }
    var byClass = document.querySelector("input.cart_id");
    if (byClass && byClass.value) {
      return byClass.value;
    }
    var match = window.location.pathname.match(
      /\/(?:one-page-checkout|payment|travelers|quotation)\/([0-9a-fA-F-]{36})(?:\/|$)/
    );
    return match ? match[1] : "";
  },

  getBoolAttr: function (el, attr, _default) {
    let value = el.getAttribute(attr);
    if (value !== null) {
      return value.toLowerCase() == "true";
    }
    return _default;
  },

  disableOnClick: function (el) {
    if (el.tagName === "A") {
      el.classList.add("disabled");
      el.style.pointerEvents = "none";
    } else {
      el.disabled = true;
    }
  },

  initTooltips: function (container) {
    if (typeof bootstrap === "undefined" || !bootstrap.Tooltip) return;
    const root = container || document;
    const trigger = "hover focus click";
    root.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(function (el) {
      const existing = bootstrap.Tooltip.getInstance(el);
      if (existing) existing.dispose();
      new bootstrap.Tooltip(el, { trigger: trigger });
    });
  },

  tooltips: {
    dateRequired:
      '<div class="fs-6"><strong>Preencha as datas</strong><br>' +
      "Para uma melhor experiência, preencha as datas e realize a busca.</div>",
  },

  _dismissValidationTooltip: null,

  /**
   * Manual tooltip for blocking validations, disposed on the next document click.
   * Callers that fire it from a click handler must stop propagation, otherwise the
   * same click dismisses it right away.
   */
  showValidationTooltip: function (element, html) {
    if (!element || typeof bootstrap === "undefined" || !bootstrap.Tooltip) return;

    kombi.hideValidationTooltip();

    const existing = bootstrap.Tooltip.getInstance(element);
    if (existing) existing.dispose();

    new bootstrap.Tooltip(element, {
      title: html,
      html: true,
      trigger: "manual",
      placement: "top",
    }).show();

    const dispose = function () {
      const instance = bootstrap.Tooltip.getInstance(element);
      if (instance) instance.dispose();
    };

    const hideAfterClick = function () {
      kombi._dismissValidationTooltip = null;
      dispose();
    };

    kombi._dismissValidationTooltip = function () {
      document.removeEventListener("click", hideAfterClick);
      kombi._dismissValidationTooltip = null;
      dispose();
    };

    document.addEventListener("click", hideAfterClick, { once: true });
  },

  hideValidationTooltip: function () {
    if (kombi._dismissValidationTooltip) kombi._dismissValidationTooltip();
  },
};

document.addEventListener("click", function (evt) {
  if (typeof bootstrap === "undefined" || !bootstrap.Tooltip) return;
  const clickedTrigger = evt.target.closest("[data-bs-toggle='tooltip']");
  const clickedInsideTooltip = evt.target.closest(".tooltip");

  if (!clickedTrigger && !clickedInsideTooltip) {
    document.querySelectorAll("[data-bs-toggle='tooltip']").forEach(function (el) {
      const t = bootstrap.Tooltip.getInstance(el);
      if (t) t.hide();
    });
  } else if (clickedTrigger) {
    document.querySelectorAll("[data-bs-toggle='tooltip']").forEach(function (el) {
      if (el !== clickedTrigger) {
        const t = bootstrap.Tooltip.getInstance(el);
        if (t) t.hide();
      }
    });
  }
}, true);

document.addEventListener("DOMContentLoaded", function () {
  kombi.searchTabs();
  kombi.search();
  kombi.searchBar();
  kombi.flatpickr();
  if (kombi.calendarMobile) kombi.calendarMobile();
  if (kombi.cleaveMask) kombi.cleaveMask();           // ausente no hotel-detail bundle
  kombi.activeLinks();
  if (kombi.paymentPagBank) kombi.paymentPagBank();   // ausente no hotel-detail bundle
  kombi.disableCollapseFields();
  if (kombi.travelersFormValidation) kombi.travelersFormValidation(); // ausente no hotel-detail bundle
  if (kombi.checkoutTimer) {                           // ausente no hotel-detail bundle
    kombi.checkoutTimer.checkAvailability();
    kombi.checkoutTimer.fixedDiv();
  }
  kombi.carousel();
  if (kombi.reservation) kombi.reservation.navLinkActiveStyle(); // ausente no hotel-detail bundle
  if (kombi.profile) kombi.profile.formatPhoneNumber();          // ausente no hotel-detail bundle
  kombi.sidebar.collapseToggle();
  kombi.sidebar.menuLinkActive();
  kombi.sidebar.mobileDropdownModal();
  kombi.sidebar.navBarFade();
  kombi.toggleReadMore.init();
  kombi.readMore();
  kombi.flight.bindDeltaPricing();
  kombi.flight.bindPackageCheckoutVisibility();
  kombi.flight.initPackageCheckoutVisibility();
  kombi.flight.calculateDeltaPricing();
  kombi.flight.changeDateMobile();
  if (kombi.reloadInstallments) kombi.reloadInstallments(); // ausente no hotel-detail bundle
  window.onload = kombi.flight.changeDateMobile;
  window.onresize = kombi.flight.changeDateMobile;
  kombi.flight.changeDateDesktop();
  kombi.accordion();
  kombi.hotel();
  kombi.packageSearchPollingLoader();
  kombi.checkSearchHash();
  kombi.travelSuitcaseNavLinkMobile();
  kombi.travelSuitcaseNavLinkDesktop();
  kombi.initTooltips();
});

// HTMX event guide (this project):
// - afterOnLoad: UI reinits on new content (amenities, rooms, prices)
// - afterSwap: one-shot body listeners via kombi.lifecycle.bindOnce / onBody
// - afterSettle: settled DOM — tooltips, analytics
const HTMX_AFTER_ON_LOAD = [
  { run: function (root) { kombi.toggleReadMore.init(root); } },
  { run: function (root) { kombi.readMore(root); } },
  { run: function (root) { kombi.carousel(root); } },
  { run: function () { kombi.flight.initPackageCheckoutVisibility(); } },
  { run: function () { kombi.flight.calculateDeltaPricing(); } },
  { run: function (root) { kombi.hotel(root); } },
  { run: function () { kombi.packageSearchPollingLoader(); } },
  { run: function () { kombi.showCartToastIfFull(); } },
];

document.body.addEventListener("htmx:afterOnLoad", function (event) {
  const root = event.target;
  HTMX_AFTER_ON_LOAD.forEach(function (entry) {
    entry.run(root);
  });
});

document.body.addEventListener("htmx:afterSettle", function (event) {
  kombi.initTooltips(event.target);
});

const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
const popoverList = [...popoverTriggerList].map(function (popoverTriggerEl) {
  return new bootstrap.Popover(popoverTriggerEl);
});
